/* eslint-disable jsx-a11y/alt-text */
import { Navigate, Outlet, Route, Routes } from "react-router-dom"
import { LoginScreen } from "../pages/LoginScreen"
import { Row } from "../../../../core/components/Row";
import { Column } from "../../../../core/components/Column";
import { Container } from "../../../../core/components/Container"
import { TextComponent } from "../../../../core/components/TextComponent";
import { RootState } from "../../../../core/store/store";
import { useSelector } from "react-redux";
import { LoadingComponent } from "../../../../core/components/LoadingComponent";
import { EmailScreen } from "../pages/EmailScreen";
import { OTPScreen } from "../pages/OTPScreen";
import { PasswordLoginScreen } from "../pages/PasswordLoginScreen";
import { LoginHelpScreen } from "../../../community/presentation/pages/LoginHelpScreen";
import { LayoutOnboarding } from "../../../profile/presentation/pages/onBoarding/LayoutOnboarding";
import { OnboardingUnvaccinated } from "../../../profile/presentation/pages/onBoarding/OnboardingUnvaccinated";
import { OnboardingAge } from "../../../profile/presentation/pages/onBoarding/OnboardingAge";
import { OnBoardingUsername } from "../../../profile/presentation/pages/onBoarding/OnBoardingUsername";
import coupleWelcome from '../../../../core/assets/coupleWelcome.jpeg';
import backgroundWelcome from '../../../../core/assets/backgroundWelcome.png';

export const AuthRoutes = () => {
  return (
    <Routes>
      <Route element={<LayoutOnboarding />}>
        <Route path="unvaccinated" element={<OnboardingUnvaccinated />} />
        <Route path="age" element={<OnboardingAge />} />
        <Route path="username" element={<OnBoardingUsername />} />
      </Route>
      <Route element={<LayoutAuth />}>
        <Route path="login" element={<LoginScreen />} />
        <Route path="email" element={<EmailScreen />} />
        <Route path="password" element={<PasswordLoginScreen />} />
        <Route path="login-help" element={<LoginHelpScreen />} />
        <Route path="otp/:recipient/:type" element={<OTPScreen />} />
      </Route>
      <Route path="/*" element={<Navigate to="/auth/login" />} />
    </Routes>
  )
}
const LayoutAuth = () => {
  const { isLoading } = useSelector((state: RootState) => state.auth);
  return (<LoadingComponent isLoading={isLoading}>
    <Row mainAxisAlignment="between" className="h-svh overflow-y-auto">

      <Container className="hidden md:flex flex-col justify-center w-1/2 px-0 relative overflow-hidden">
       
        <img
          src={backgroundWelcome}
          alt="background"
          className="absolute inset-0 w-full h-full object-cover"
        />
        
        <div className="absolute inset-0 flex top-1/3 left-2/4 justify-center">
          <Column>
            <img
                src="/unjabbed.png"
                alt="unjabbed-logo"
                className="w-64"
                width={632}
                height={192}
            />
          <TextComponent variant="h3" className="mt-5 text-white text-center">
            The Dating App For <br/> People Who Value
          </TextComponent>
          <TextComponent variant="h2" className="mt-2 text-primary text-center font-bold">
            FREEDOM OF CHOICE
          </TextComponent>
          </Column>
        </div>

        <img
          src={coupleWelcome}
          alt="welcome"
          className="absolute inset-0 w-full h-full object-cover"
          style={{ clipPath: 'polygon(0 0, 25% -80%, 58% 100%, 0% 100%)' }}
        />

        <div
          className="absolute inset-0 w-full h-full pointer-events-none bg-primary"
          style={{
            clipPath: 'polygon(0% -90%, 29.5% -70%, 60% 112%, 25%  -80%)',
          }}
        />
      </Container>

      <Outlet />
    </Row>
  </LoadingComponent>)
};
